/* Approved UnderSwim artwork, 20 October 2026.
 * Reversible website composition over named legacy graphics. Source photos and
 * packaging remain unchanged; supplied SVG artwork is never redrawn/recoloured.
 */
(() => {
  const script = document.currentScript;
  if (!script || window.elteeUnderSwimIdentity) return;
  window.elteeUnderSwimIdentity = true;
  const marks = { og: script.dataset.og, white: script.dataset.ogWhite, gfit: script.dataset.gfit };
  // Coordinates are fractions of each original, uncropped promotional graphic.
  const placements = [
    { file: 'UNDERSWIM_MOBILE_ELTEE_SYDNEY.png', rect: [0, 0, 1, .145], mark: 'white', background: '#2E2A39', fit: '82% auto', foregrounds: [
      'polygon(67% 14.5%,67% 12.5%,67.5% 11.25%,68.25% 10%,69.25% 8.75%,70.5% 7.5%,72.25% 6.5%,73.75% 6.3%,75.25% 6.6%,76.75% 7.1%,78.25% 8%,79.25% 9.2%,80% 10.7%,80.6% 12.2%,80.8% 14.5%)',
      'polygon(25% 13%,36% 13%,35.8% 14.5%,24.8% 14.5%)'
    ] },
    { file: 'UNDERSWIM_GFIT_NEUTRAL_BLACK.jpg', page: '/pages/girls-periods-pool', scope: '[id^="SectionColumns--"][id$="__products"]', rect: [.225, .09, .575, .145], mark: 'gfit', background: '#FFFBF2', fit: '92% auto', label: 'NEW' },
    { file: 'UNDERSWIM_TECH_SUIT_LP.jpg', rect: [.035, .18, .34, .15], mark: 'white', background: '#232b3e', fit: '100% auto' },
    { file: 'ELTEE_SYDNEY_UNDERSWIM_COMPLIANCE.jpg', rect: [.20, .35, .45, .17], mark: 'og', background: '#FFFBF2', fit: '100% auto' },
    { file: 'MULTICLASS_SWIMMING_ELTEE_SYDNEY_LP_HEADER.png', rect: [.02, .065, .34, .16], mark: 'og', background: '#e6f8f5', fit: '100% auto' }
  ];
  const attached = new WeakSet();
  const observers = new Set();
  function attach(image, placement) {
    if (attached.has(image)) return;
    attached.add(image);
    const host = image.parentElement;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    const layer = document.createElement('span');
    layer.dataset.underswimIdentity = placement.mark;
    layer.setAttribute('aria-hidden', 'true');
    Object.assign(layer.style, {
      position: 'absolute', display: 'block', pointerEvents: 'none', zIndex: '2',
      backgroundColor: placement.background,
      backgroundImage: `url("${marks[placement.mark]}")`,
      backgroundRepeat: 'no-repeat', backgroundPosition: 'center',
      backgroundSize: placement.fit, overflow: placement.label ? 'visible' : 'hidden',
      borderRadius: placement.label ? '5px' : '0'
    });
    if (placement.label) {
      const label = document.createElement('span');
      label.textContent = placement.label;
      Object.assign(label.style, {
        position: 'absolute', left: '5%', bottom: '-8px', padding: '4px 8px',
        borderRadius: '5px', backgroundColor: '#813F8E', color: '#FFFFFF',
        fontFamily: 'system-ui, sans-serif', fontWeight: '700', lineHeight: '1'
      });
      layer.append(label);
    }
    host.append(layer);
    // Keep the original foreground heads/hair above the replaced header mark.
    // These are clipped views of the unchanged source photo, not generated people.
    const foregrounds = (placement.foregrounds || []).map(clipPath => {
      const foreground = document.createElement('span');
      foreground.setAttribute('aria-hidden', 'true');
      Object.assign(foreground.style, { position: 'absolute', display: 'block',
        pointerEvents: 'none', zIndex: '3', clipPath, backgroundRepeat: 'no-repeat',
        backgroundSize: '100% 100%' });
      host.append(foreground);
      return foreground;
    });
    function position() {
      const box = image.getBoundingClientRect();
      const parent = host.getBoundingClientRect();
      if (!box.width || !box.height || !image.naturalWidth) { layer.hidden = true; return; }
      layer.hidden = false;
      const css = getComputedStyle(image);
      const naturalRatio = image.naturalWidth / image.naturalHeight;
      let width = box.width, height = box.height;
      if (css.objectFit === 'cover') {
        width = Math.max(box.width, box.height * naturalRatio);
        height = width / naturalRatio;
      } else if (css.objectFit === 'contain') {
        width = Math.min(box.width, box.height * naturalRatio);
        height = width / naturalRatio;
      }
      const parts = css.objectPosition.split(' ');
      const fraction = value => value?.endsWith('%') ? parseFloat(value) / 100 : .5;
      const cropX = (box.width - width) * fraction(parts[0]);
      const cropY = (box.height - height) * fraction(parts[1]);
      const [x, y, w, h] = placement.rect;
      // Clip the layer to the visible photo, including mobile object-fit crops.
      const left = Math.max(0, cropX + width * x);
      const top = Math.max(0, cropY + height * y);
      const right = Math.min(box.width, cropX + width * (x + w));
      const bottom = Math.min(box.height, cropY + height * (y + h));
      const scaleX = host.clientWidth / parent.width || 1;
      const scaleY = host.clientHeight / parent.height || 1;
      Object.assign(layer.style, {
        left: `${(box.left - parent.left + left) * scaleX - host.clientLeft}px`,
        top: `${(box.top - parent.top + top) * scaleY - host.clientTop}px`,
        width: `${Math.max(0, right - left) * scaleX}px`,
        height: `${Math.max(0, bottom - top) * scaleY}px`
      });
      for (const foreground of foregrounds) {
        Object.assign(foreground.style, {
          backgroundImage: `url("${image.currentSrc || image.src}")`,
          left: `${(box.left - parent.left + cropX) * scaleX - host.clientLeft}px`,
          top: `${(box.top - parent.top + cropY) * scaleY - host.clientTop}px`,
          width: `${width * scaleX}px`, height: `${height * scaleY}px`
        });
      }
      if (placement.label) layer.firstElementChild.style.fontSize = `${Math.max(12, width * .0275)}px`;
    }
    const observer = new ResizeObserver(position);
    observers.add(observer);
    observer.observe(image);
    image.addEventListener('load', position);
    position();
  }
  function scan() {
    for (const image of document.images) {
      const src = decodeURIComponent(image.currentSrc || image.src);
      const placement = placements.find(item => src.split('?')[0].endsWith('/' + item.file)
        && (!item.page || location.pathname === item.page)
        && (!item.scope || image.closest(item.scope)));
      if (placement) attach(image, placement);
    }
  }
  scan();
  document.addEventListener('shopify:section:load', scan);
})();
